export const siteLanguagesEnglish = 'en';
export const siteLanguagesFrench = 'fr';
export const globalErrorMsgEnglish = 'Default card cannot be deleted. Please set another card as default before deleting this card.';
export const globalErrorMsgFrench = 'La carte par défaut ne peut pas être supprimée. Veuillez définir une autre carte par défaut avant de supprimer cette carte';